import React from 'react';

interface DynamicGridRowProps {
    className?: string;
    children: React.ReactNode;
}

export function DynamicGridRow({ className, children }: DynamicGridRowProps) {
    return <tr className={className}>{children}</tr>;
}
